var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.confirmDeactivateTemplate > -1
    },
    on: {
      "close": _vm.close
    }
  }, [_vm.confirmDeactivateTemplate == 0 ? _c('div', [_c('div', {
    staticClass: "my-5 xl:my-15"
  }, [_c('h3', {
    staticClass: "mb-5 md:mb-10 2xl:mb-15"
  }, [_vm._v("\n        Desactiver le modèle de page \"" + _vm._s(_vm.templateNameToDeactivate) + "\"\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          Êtes-vous sûr de vouloir désactiver le modèle de page \"" + _vm._s(_vm.templateNameToDeactivate) + "\" ?\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-4 justify-center bg-pink"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-pink-600",
      "bg-color": "bg-pink-300",
      "libelle": "ANNULER"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.close(-1);
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "uppercase": true,
      "libelle": "Désactiver",
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": _vm.confirm_deactivate_template
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _vm.confirmDeactivateTemplate == 1 ? _c('div', [_c('h3', {
    staticClass: "w-full text-indigo-600 mt-12 mb-10"
  }, [_vm._v("\n      Le modèle de page \"" + _vm._s(_vm.templateNameToDeactivate) + "\""), _c('br'), _vm._v("a bien été désactivé !\n    ")]), _vm._v(" "), _c('illustration', {
    staticClass: "w-full m-5",
    attrs: {
      "name": "basket"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.confirmDeactivateTemplate == 2 ? _c('div', [_c('div', {
    staticClass: "my-5 xl:my-15"
  }, [_c('h3', {
    staticClass: "mb-5 md:mb-10 2xl:mb-15"
  }, [_vm._v("\n        Désactiver le modèle de page \"" + _vm._s(_vm.templateNameToDeactivate) + "\"\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          Êtes-vous sûr de vouloir désactiver le modèle de page \"" + _vm._s(_vm.templateNameToDeactivate) + "\" ?\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "text-pink-600 text-lg text-center"
  }, [_vm._v("\n          Attention, ce modèle de page est utilisé par " + _vm._s(_vm.listAssignedUsersTemplate.length) + " bénéficiaire"), _vm.listAssignedUsersTemplate.length > 1 ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v(" :\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text-pink-600 text-lg text-center mb-5"
  }, _vm._l(_vm.listAssignedUsersTemplate, function (beneficiary, index) {
    return _c('span', {
      key: beneficiary.id
    }, [index > 0 ? _c('span', [_vm._v("- ")]) : _vm._e(), _vm._v(_vm._s(beneficiary.firstname) + " "), _c('span', {
      staticClass: "uppercase"
    }, [_vm._v(_vm._s(beneficiary.lastname))])]);
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "text-pink-600 text-lg text-center"
  }, [_vm._v("\n          En cas de désactivation, le modèle de page \"" + _vm._s(_vm.templatePageToAssignAfterDelete.name) + "\" " + _vm._s(_vm.listAssignedUsersTemplate.length > 1 ? 'leur' : 'lui') + " sera attribué.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-4 justify-center bg-pink"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-pink-600",
      "bg-color": "bg-pink-300",
      "libelle": "ANNULER"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.close(-1);
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "uppercase": true,
      "libelle": "DESACTIVER",
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.confirm_deactivate_template(_vm.templatePageToAssignAfterDelete);
      }
    }
  })], 1)])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }